import { Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from "@nextui-org/react"
import React,{ useEffect, useMemo, useState } from "react"

const OrderNoDetail = ({ data, handleOrderNoDetail }) => {
    const [selOrderNo, setSelOrderNo] = useState("0")
    useEffect(() => {
        handleOrderNoDetail(selOrderNo)
    }, [selOrderNo])
    const classNames = useMemo(
        () => ({
        //  wrapper: ["max-h-[382px]", "max-w-3xl"],
          th: ["bg-blue-700","text-center", "font-semibold","text-white", "text-xs","p-1","m-0" ,"rounded-none"],
          td: ["text-xs","px-1","py-2","m-0","text-center"
            
          ],
        }),
        [data],
      );
    return (
        <Table
            selectionMode="single"
            isHeaderSticky
            color={"danger"}
            selectedKeys={[String(selOrderNo)]}
            onSelectionChange={(e) => setSelOrderNo(Array.from(e)[0] ?? 0)}
            aria-label="Order Details"
            classNames={classNames}
            removeWrapper={true}
            className={"m-3 mb-10"}
        >
            <TableHeader>
                <TableColumn className="" >ORD NO</TableColumn>
                <TableColumn className="">ORD DATE</TableColumn>
                <TableColumn className="">PO No</TableColumn>
                <TableColumn className="">BTAKA</TableColumn>
                <TableColumn className="">BMETER</TableColumn>
                <TableColumn className="">RATE</TableColumn>
                <TableColumn className="">OTAKA</TableColumn>
                <TableColumn className="">OMETER</TableColumn>
                <TableColumn className="">DISC PER</TableColumn>
                {/* <TableColumn className="">DTAKA</TableColumn>
                <TableColumn className="">DMETER</TableColumn>
                <TableColumn className="">PARTY ID</TableColumn>
                <TableColumn className="">PARTY DESC</TableColumn>
                <TableColumn className="">ITEM CODE</TableColumn>
                <TableColumn className="">ITEM DESC</TableColumn>
                <TableColumn className="">ENTRY TYPE</TableColumn>
                <TableColumn className="">DTAKA</TableColumn>
                <TableColumn className="">DMETER</TableColumn>
                <TableColumn className="">BAC ID</TableColumn>
                <TableColumn className="">BAC DESC</TableColumn>
                <TableColumn className="">DUE DAYS</TableColumn> */}

            </TableHeader>
            <TableBody>
                {
                    data && data.length > 0 &&
                    data.map((ele) => {
                        return (
                            <TableRow className="border-1" key={ele.Order_No}>
                                <TableCell>{ele?.Order_No}</TableCell>
                                <TableCell>{ele?.Order_Date}</TableCell>
                                <TableCell>{ele?.po_no}</TableCell>
                                <TableCell>{ele?.PndSalTaka}</TableCell>
                                <TableCell>{ele?.PndSalMtr}</TableCell>
                                <TableCell>{ele?.Rate}</TableCell>
                                <TableCell>{ele?.OTAKA}</TableCell>
                                <TableCell>{ele?.OMETER}</TableCell>
                                <TableCell>{ele?.Disc_Per}</TableCell>

                                {/* <TableCell>{ele?.DTaka}</TableCell>
                                <TableCell>{ele?.DMeter}</TableCell>
                                <TableCell>{ele?.Party_Id}</TableCell>
                                <TableCell>{ele?.Party_Desc}</TableCell>
                                <TableCell>{ele?.Item_Code}</TableCell>
                                <TableCell>{ele?.Item_Desc}</TableCell>
                                <TableCell>{ele?.Entry_Type}</TableCell>
                                <TableCell>{ele?.DTaka}</TableCell>
                                <TableCell>{ele?.DMeter}</TableCell>
                                <TableCell>{ele?.BAc_Id}</TableCell>
                                <TableCell>{ele?.BAc_Desc}</TableCell>
                                <TableCell>{ele?.DueDays}</TableCell> */}
                            </TableRow>
                        )
                    })
                }
            </TableBody>
        </Table>
    )

}
export default OrderNoDetail